import React from 'react';
import { useLanguage } from '../LanguageContext';
import { CONTENT } from '../content';

export default function Onboarding() {
  const { language } = useLanguage();
  const t = CONTENT[language].onboarding;

  const colors = [
    { ball: 'bg-suncoast-primary', text: 'text-suncoast-primary' },
    { ball: 'bg-suncoast-secondary', text: 'text-suncoast-secondary' },
    { ball: 'bg-suncoast-accent', text: 'text-suncoast-accent' }
  ];

  return (
    <div className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-12 max-w-4xl">
        <h1 className="text-4xl font-bold text-center mb-12 text-suncoast-dark">{t.title}</h1>
        
        <div className="relative border-l-4 border-suncoast-primary ml-4 md:ml-12 space-y-12">
          
          {t.steps.map((step, index) => (
             <div key={index} className="relative pl-8 md:pl-12">
              <div className={`absolute -left-[14px] top-0 w-6 h-6 rounded-full ${colors[index].ball} border-4 border-white`}></div>
              <h3 className={`text-xl font-bold ${colors[index].text} mb-2`}>{step.title}</h3>
              <ul className="list-disc ml-5 space-y-2 text-gray-700">
                {step.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          ))}

        </div>
      </div>
    </div>
  );
}
